var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "9px",
    viewBox: "0 0 15 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FA1FB51C-87CE-41E3-AA1F-C06987931BDF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BackOffice",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_\\xC1rea-logada",
    transform: "translate(-1115.000000, -39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Header",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next-(1)",
    transform: "translate(1114.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.1,8.8 L14.8,2 C15,1.8 15,1.6 15,1.4 C15,1.2 14.9,1 14.8,0.8 L14.3,0.3 C14,1.33226763e-15 13.5,1.33226763e-15 13.1,0.3 L7.6,6 L1.9,0.2 C1.8,0.1 1.6,0 1.4,0 C1.1,0 0.9,0.1 0.8,0.2 L0.3,0.7 C0.1,0.9 0.1,1.1 0.1,1.3 C0.1,1.5 0.2,1.7 0.3,1.9 L7,8.8 C7.1,8.9 7.3,9 7.6,9 C7.8,9 8,8.9 8.1,8.8 Z",
    id: "Path",
    fill: "#FF822F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,8.8 L14.8,2 C15,1.8 15,1.6 15,1.4 C15,1.2 14.9,1 14.8,0.8 L14.3,0.3 C14,1.33226763e-15 13.5,1.33226763e-15 13.1,0.3 L7.6,6 L1.9,0.2 C1.8,0.1 1.6,0 1.4,0 C1.1,0 0.9,0.1 0.8,0.2 L0.3,0.7 C0.1,0.9 0.1,1.1 0.1,1.3 C0.1,1.5 0.2,1.7 0.3,1.9 L7,8.8 C7.1,8.9 7.3,9 7.6,9 C7.8,9 8,8.9 8.1,8.8 Z",
    id: "Path_1_",
    fill: "#E71037"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.637031ed.svg";
export { ForwardRef as ReactComponent };